import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { startGateway } from '@/ha/runtime'
import { router } from './router'
import { ConnectionBanner } from './ConnectionBanner'
import { UpdateWatcher } from './UpdateWatcher'
import { useThemeEffect } from './theme'

export function App() {
  const [booted, setBooted] = useState(false)
  useThemeEffect()

  useEffect(() => {
    let alive = true
    startGateway()
      .then(() => alive && setBooted(true))
      .catch((err) => {
        console.error('gateway start failed', err)
        if (alive) setBooted(true) // render anyway; banner shows the connection state
      })
    return () => {
      alive = false
    }
  }, [])

  if (!booted) {
    return (
      <div className="grid h-full place-items-center bg-[var(--color-bg)] text-[var(--color-muted)]">
        <div className="flex flex-col items-center gap-3">
          <div className="h-7 w-7 animate-spin rounded-full border-2 border-[var(--color-surface-3)] border-t-[var(--color-accent)]" />
          <span className="text-sm tracking-wide">Kobler til Home Assistant…</span>
        </div>
      </div>
    )
  }

  return (
    <>
      <ConnectionBanner />
      <UpdateWatcher />
      <RouterProvider router={router} />
      <Toaster position="top-center" theme="dark" richColors closeButton />
    </>
  )
}
